import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { supabase, isSupabaseConfigured } from '../supabaseClient';

function OptOut() {
	const [phone, setPhone] = useState('');
	const [status, setStatus] = useState(null);
	const [submitting, setSubmitting] = useState(false);

	const submit = async (e) => {
		e.preventDefault();
		setSubmitting(true);
		setStatus(null);
		try {
			if (!isSupabaseConfigured) {
				setStatus({ ok: false, msg: 'Opt-out storage is not configured yet. Please reply STOP to any message to opt out.' });
				return;
			}
			await supabase.from('sms_unsubscribes').insert([{
				phone,
				referral_url: window.location.href,
				user_agent: navigator.userAgent,
				website: 'appexconnecthub.com'
			}]);
			setStatus({ ok: true, msg: 'Your number has been added to our opt-out list.' });
			setPhone('');
		} catch (err) {
			console.error(err);
			setStatus({ ok: false, msg: 'Something went wrong. Please try again.' });
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<section className="section">
			<div className="container">
				<Helmet>
					<title>Opt-Out • Appex Connect Hub</title>
				</Helmet>
				<h2>Opt-Out</h2>
				<p className="helper">
					You can opt out by replying STOP to any message. You may also submit your mobile number here to add it
					to our internal opt-out list. Opt-outs are honored immediately.
				</p>
				<p className="helper">Need help? Email <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a>.</p>
				<form className="form form-grid" style={{ marginTop: 16, maxWidth: 520 }} onSubmit={submit}>
					<div className="field">
						<label htmlFor="phone">Mobile Phone</label>
						<input id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} required />
					</div>
					<div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-start' }}>
						<button className="btn" type="submit" disabled={submitting}>
							{submitting ? 'Submitting…' : 'Submit Opt-Out'}
						</button>
					</div>
				</form>
				{status && (
					<p className="helper" style={{ color: status.ok ? 'green' : 'crimson', marginTop: 10 }}>
						{status.msg}
					</p>
				)}
			</div>
		</section>
	);
}

export default OptOut;


